import { useNavigate } from "react-router-dom";

const Cleartax = () => {
  const navigate = useNavigate();
  return (
    <div className="rounded-[12px] bg-white p-6">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">File Your Taxes</h1>
        <div className="flex-grow-0 flex flex-row justify-start items-center gap-1 py-[2px] px-[8px] rounded-[17px] bg-[#ee4d37] w-[43px] h-[17px]">
          <span className="text-white text-xs">New</span>
        </div>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="bg-[linear-gradient(57deg,#090909_1%,#292929_98%)] text-white p-6 rounded-[10px] w-full mt-4 relative overflow-hidden">
        <img
          src="/assets/money/tax/tax.webp"
          alt="legacy planning"
          className="absolute right-4 w-[138px] h-[162px] top-[50px]"
        />
        <h2 className="text-[24px] font-bold w-2/3 pt-3">
          File Your Taxes Easily & Save More!
        </h2>
        <h4 className="text-[16px] w-2/3 mt-4">
          Enjoy exclusive 1% Club discount!
        </h4>
        <button
          className="bg-[#007aff] py-[8px] px-[16px] text-[15px] rounded-full leading-[1.33] mt-[33px] font-bold"
          onClick={() => navigate("/money/protect/tax")}
        >
          Explore
        </button>
      </div>
    </div>
  );
};

export default Cleartax;
